import { render, staticRenderFns } from "./LiveChatWidgetPanel.vue?vue&type=template&id=2b5a146e"
import script from "./LiveChatWidgetPanel.vue?vue&type=script&lang=js"
export * from "./LiveChatWidgetPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports